import { createContext, Dispatch, SetStateAction } from 'react';

export interface LayoutContextProps {
  fullScreenVideo: boolean;
  // Header element next to the language switcher where pages render extra controls (e.g. the quiz timer)
  headerSlot: HTMLElement | null;
  setFullScreenVideo: Dispatch<SetStateAction<boolean>>;
  setHeaderSlot: (element: HTMLElement | null) => void;
}

export const LayoutContext = createContext<LayoutContextProps | undefined>(undefined);
